export const isVendorProfileComplete = (user) => {
    const requiredFields = [
      user.vendor_type,
      user.business_name,
      user.full_name,
      user.professional_title,
      user.work_email,
      user.phone_number,
      user.address,
      user.description,
    ];
  
    const hasAllFields = requiredFields.every((field) => field && field.trim() !== "");
  
    const isLocationSet = Array.isArray(user.location?.coordinates) &&
      !(user.location.coordinates[0] === 0 && user.location.coordinates[1] === 0);
  
      const hasAtLeastOneService =
      (Array.isArray(user.services) && user.services.length > 0) || // ✅ new check
      user.services_provided ||
      user.mortgage_pre_approval ||
      user.investment_property_loans ||
      user.home_equity_loans ||
      user.first_time_home_buyer_loans ||
      user.debt_consolidation ||
      user.custom_loan_solutions ||
      user.refinancing_services ||
      user.interest_rate_optimization ||
      user.construction_loans ||
      user.loan_application_assistance ||
      user.government_backed_loans ||
      user.reverse_mortgages ||
      user.credit_score_consultation;
    return hasAllFields && isLocationSet && hasAtLeastOneService;
  };
  